export const APP_ROUTES = {
  ROOT: "/",
  GET_STARTED: "/get-started",
  REFER: "/refer",
  MEET_THE_TEAM: "/meet-the-team",
  SCREENER: "/screener",
  FIND_PROVIDER: "/find-provider",
  PROVIDER_PROFILE: "/provider-profile",
  PATIENT_INFORMATION: "/patient-information",
  APPOINTMENT_CONFIRMED: "/appointment-confirmed",
  PAGE_NOT_FOUND: "/page-not-found",
  CONTACT_US: "/contact-us",
  ERROR: "/error",
  HEALTH_CHECK: "/health-check",
  CONTACT: "/contact",
} as const;

export type AppRoutePath = (typeof APP_ROUTES)[keyof typeof APP_ROUTES];

export const PROVIDER_SELECTION_ROUTE_PATHS = [
  APP_ROUTES.FIND_PROVIDER,
  APP_ROUTES.PROVIDER_PROFILE,
] as const;

export type ProviderSelectionRoutePath = (typeof PROVIDER_SELECTION_ROUTE_PATHS)[number];

export const PROVIDER_SELECTION_SOURCE_PATHS = [
  APP_ROUTES.MEET_THE_TEAM,
  APP_ROUTES.FIND_PROVIDER,
] as const;

export type ProviderSelectionSourcePath = (typeof PROVIDER_SELECTION_SOURCE_PATHS)[number];
